// Ubicación en el repo: src/components/PatientsExport.jsx
// Sub-pestaña "Exportar" de Configuración (DECISIONS.md #118, pedido de
// Nicolás 16-sep-2026, tema 5 de 5). Un solo botón: genera y descarga el
// .xlsx directo en el navegador, sin pasos intermedios.
import { useState } from 'react';
import { downloadPatientsExcel } from '../lib/patientsExport';

export default function PatientsExport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [lastCount, setLastCount] = useState(null);

  async function handleDownload() {
    setLoading(true);
    setError('');
    setLastCount(null);
    try {
      const count = await downloadPatientsExcel();
      setLastCount(count);
    } catch (err) {
      setError(err.message || 'No se pudo generar el archivo.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="patients-page">
      <h1>Exportar pacientes</h1>
      <p className="field-hint" style={{ marginBottom: 16 }}>
        Descarga un archivo Excel (.xlsx) con los datos personales y de contacto de los pacientes activos a
        los que tienes acceso (mismo criterio de permisos que en Pacientes). Los pacientes en la papelera no
        se incluyen.
      </p>

      <div className="card-panel">
        <h3 style={{ marginTop: 0 }}>Listado de pacientes</h3>
        <p className="field-hint">
          Incluye nombre completo, RUT, fecha de nacimiento, sexo, teléfono, correo, dirección, previsión,
          contacto de emergencia y sucursal(es).
        </p>
        <button type="button" className="button-primary" onClick={handleDownload} disabled={loading}>
          {loading ? 'Generando…' : '📊 Descargar listado de pacientes (.xlsx)'}
        </button>
        {lastCount !== null && !error && (
          <p className="field-hint" style={{ marginTop: 10 }}>
            Listo — se descargaron {lastCount} paciente{lastCount === 1 ? '' : 's'}.
          </p>
        )}
        {error && (
          <p className="auth-error" style={{ marginTop: 10 }}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
